import React from 'react';
import { Box, Typography, SxProps, Theme, useTheme } from '@mui/material';
import BookIcon from '@mui/icons-material/Book';
import { useAIDTMediaQuery } from '../../hooks';
import { EliceLayout } from '../layout';

export interface HeaderTitleProps {
  title: string;
  breadcrumbItems?: string[];
  icon?: React.ReactNode;
  type?: 'breadcrumb';
  backgroundColor?: string;
  sx?: SxProps<Theme>;
}

const HeaderTitle = ({
  title,
  breadcrumbItems,
  icon,
  type = 'breadcrumb',
  backgroundColor,
  sx,
  ...rest
}: HeaderTitleProps): JSX.Element => {
  const theme = useTheme();
  const { isNotebook, isTablet } = useAIDTMediaQuery();

  if (isTablet) {
    const baseSx = {
      backgroundColor: `${backgroundColor || theme.palette.primary.main} !important`,
    };
    const mergedSx =
      sx !== undefined
        ? Array.isArray(sx)
          ? [baseSx, ...sx]
          : [baseSx, sx]
        : baseSx;
    return (
      <EliceLayout.HeaderTitle sx={mergedSx} {...rest}>
        {title}
      </EliceLayout.HeaderTitle>
    );
  }


  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={2}
      bgcolor="white"
      borderBottom="1px solid #e0e0e0"
      sx={{
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        gap: 1,
        ...sx,
      }}
    >
      {/* Left: Main Title Area */}
      <Box
        display="flex"
        alignItems="center"
        gap={1.5}
        sx={{ flex: '0 0 auto' }}
      >
        {icon ? (
          icon
        ) : (
          <BookIcon
            sx={{
              fontSize: '1.5rem',
              color: '#7c3aed',
            }}
          />
        )}
        <Typography
          variant="h1"
          fontWeight="bold"
          color="primary.main"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'unset',
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Right: Breadcrumb Area (Conditional Rendering) */}
      {!isNotebook && breadcrumbItems && breadcrumbItems.length > 0 && (
        <Box
          sx={{
            flex: '1 1 auto',
            justifyContent: 'flex-end',
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          <Typography
            variant="caption"
            fontWeight="normal"
            color="text.secondary"
            sx={{
              fontSize: {
                xs: '0.75rem',
                sm: '0.8125rem',
                md: '0.875rem',
              },
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              minWidth: 0,
            }}
          >
            {breadcrumbItems.join(' | ')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default HeaderTitle;


